<div class="card">

  <!-- Titre de la page -->
  <h2 class="page-title">
    Gestion des Devis
  </h2>

  <!-- Barre supérieure -->
  <div class="data-header">

    <!-- Filtre -->
    <mat-form-field class="filter-field">
      <mat-label>Filtre</mat-label>

      <input
        matInput
        type="text"
        (keyup)="applyFilter($event)"
      />
    </mat-form-field>

    <!-- Export Excel -->
    <button
      mat-raised-button
      class="indigo"
      [style.background-color]="theme.getColor('Main Dark')"
      (click)="exportData()"
    >
      <mat-icon>get_app</mat-icon>
      Export Excel
    </button>

  </div>

  <!-- Carte avec bordure et coins arrondis -->
  <div class="table-card">

    <!-- Conteneur avec scroll vertical -->
    <div class="table-scroll">

      <mat-table
        class="table-container"
        [dataSource]="devisList"
        matSort
        (matSortChange)="announceSortChange($event)"
      >

        <!-- ===============================================================
             N° Devis
             =============================================================== -->

        <ng-container matColumnDef="devisReference">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            N° Devis
          </mat-header-cell>

          <mat-cell *matCellDef="let row">
            {{ row.devisReference ?? '—' }}
          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Montant prévisionnel
             =============================================================== -->

        <ng-container matColumnDef="montantTotal">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Montant prév.
          </mat-header-cell>

          <mat-cell *matCellDef="let row">

            <span *ngIf="row.devisMontantTotal != null">
              {{ row.devisMontantTotal | number:'1.2-2' }} €
            </span>

            <span *ngIf="row.devisMontantTotal == null">
              —
            </span>

          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Bénéficiaire
             =============================================================== -->

        <ng-container matColumnDef="beneficiaire">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Bénéficiaire
          </mat-header-cell>

          <mat-cell *matCellDef="let row">
            {{ row.devisBeneficiaire ?? '—' }}
          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Division
             =============================================================== -->

        <ng-container matColumnDef="febDivisionDemandeurNom">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Division
          </mat-header-cell>

          <mat-cell *matCellDef="let row">
            {{ row.febDivisionDemandeurNom ?? '—' }}
          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Projet
             =============================================================== -->

        <ng-container matColumnDef="febProjetNom">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Projet
          </mat-header-cell>

          <mat-cell *matCellDef="let row" [matTooltip]="row.febProjectNom ?? ''">
            <span class="project-name">{{ row.febProjectNom ?? '—' }}</span>
          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Date de démarrage
             =============================================================== -->

        <ng-container matColumnDef="febDateDemarrage">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Démarrage
          </mat-header-cell>

          <mat-cell *matCellDef="let row">

            <span *ngIf="row.devisDateDemarrageGo">
              {{ row.devisDateDemarrageGo | date:'dd/MM/yyyy' }}
            </span>

            <span *ngIf="!row.devisDateDemarrageGo">
              —
            </span>

          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Durée prévisionnelle
             =============================================================== -->

        <ng-container matColumnDef="febDuree">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Durée (j)
          </mat-header-cell>

          <mat-cell *matCellDef="let row">

            <span *ngIf="row.devisDuree != null">
              {{ row.devisDuree }}
            </span>

            <span *ngIf="row.devisDuree == null">
              —
            </span>

          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Statut
             =============================================================== -->

        <ng-container matColumnDef="devisStatut">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Statut
          </mat-header-cell>

          <mat-cell *matCellDef="let row">

            <span
              class="badge-statut"
              [ngClass]="{
                'statut-cree':
                  row.devisStatut === DevisStatut.CREE,

                'statut-en-attente':
                  row.devisStatut === DevisStatut.EN_ATTENTE,

                'statut-accepte':
                  row.devisStatut === DevisStatut.ACCEPTE,

                'statut-refuse':
                  row.devisStatut === DevisStatut.REFUSE,

                'statut-archive':
                  row.devisStatut === DevisStatut.ARCHIVE
              }"
            >
              {{ row.devisStatut ?? '—' }}
            </span>

          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Date de création
             =============================================================== -->

        <ng-container matColumnDef="devisCreatedAt">

          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Date création
          </mat-header-cell>

          <mat-cell *matCellDef="let row">

            <span *ngIf="row.devisCreatedAt">
              {{ row.devisCreatedAt | date:'dd/MM/yyyy HH:mm' }}
            </span>

            <span *ngIf="!row.devisCreatedAt">
              —
            </span>

          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             Actions
             =============================================================== -->

        <ng-container matColumnDef="actions">

          <mat-header-cell
            *matHeaderCellDef
            class="actions-td"
          >
            Actions
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            class="actions-td"
          >

            <div class="actions-buttons">

              <!-- Visualiser -->
              <button
                mat-icon-button
                color="primary"
                type="button"
                (click)="openViewDialog(row)"
                matTooltip="Visualiser le devis"
              >
                <mat-icon>visibility</mat-icon>
              </button>

              <!-- Valider -->
              <button
                *ngIf="canValider(row)"
                mat-icon-button
                type="button"
                class="btn-valider"
                (click)="openValiderDialog(row)"
                matTooltip="Valider"
              >
                <mat-icon>check_circle</mat-icon>
              </button>

              <!-- Refuser -->
              <button
                *ngIf="canRefuser(row)"
                mat-icon-button
                color="warn"
                type="button"
                (click)="openRefuserDialog(row)"
                matTooltip="Refuser"
              >
                <mat-icon>cancel</mat-icon>
              </button>

              <!-- Voir / Modifier -->
              <button
                *ngIf="canEdit(row)"
                mat-icon-button
                type="button"
                (click)="openDialog(row)"
                matTooltip="Voir / Modifier"
              >
                <mat-icon>mode_edit</mat-icon>
              </button>

              <!-- Retour en arrière -->
              <button
                *ngIf="canRetourArriere(row)"
                mat-icon-button
                color="accent"
                type="button"
                (click)="openRetourDialog(row)"
                matTooltip="Envoyer au CDC"
              >
                <mat-icon>undo</mat-icon>
              </button>

              <!-- Soumettre à la SNCF -->
              <button
                *ngIf="canSendToSncf(row)"
                mat-icon-button
                color="primary"
                type="button"
                (click)="sendToSncf(row)"
                matTooltip="Soumettre à la SNCF"
              >
                <mat-icon>send</mat-icon>
              </button>

              <!-- Supprimer -->
              <button
                *ngIf="canDelete(row)"
                mat-icon-button
                color="warn"
                type="button"
                (click)="deleteDevis(row)"
                matTooltip="Supprimer"
              >
                <mat-icon>delete</mat-icon>
              </button>

              <!-- Archiver -->
              <button
                *ngIf="canArchive(row)"
                mat-icon-button
                type="button"
                class="btn-archive"
                (click)="archiveDevis(row)"
                matTooltip="Archiver"
              >
                <mat-icon>archive</mat-icon>
              </button>

              <!-- Télécharger -->
              <button
                *ngIf="canDownload(row)"
                mat-icon-button
                type="button"
                class="btn-download"
                (click)="downloadDevis(row)"
                matTooltip="Télécharger"
              >
                <mat-icon>download</mat-icon>
              </button>

            </div>

          </mat-cell>

        </ng-container>

        <!-- ===============================================================
             En-tête fixe
             =============================================================== -->

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        >
        </mat-header-row>

        <!-- ===============================================================
             Lignes
             =============================================================== -->

        <mat-row
          *matRowDef="let row; columns: displayedColumns;"
        >
        </mat-row>

        <!-- ===============================================================
             Aucun résultat
             =============================================================== -->

        <tr
          class="mat-row no-data-row"
          *matNoDataRow
        >
          <td
            class="mat-cell"
            [attr.colspan]="displayedColumns.length"
          >
            Aucun devis trouvé.
          </td>
        </tr>

      </mat-table>

    </div>

  </div>

</div>